import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule, MatButtonModule,
     MatIconModule, MatInputModule,
      MatAutocompleteModule, MatSelectModule, MatCardModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SearchInputComponent } from './search-input.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    TranslateModule,
  ],
  declarations: [SearchInputComponent],
  exports: [SearchInputComponent]
})
export class SearchInputModule { }
